import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { QUERY_SEARCH_GAMES } from "common/src/graphql/queries";
import { isMobile } from "react-device-detect";
import { useApolloClient } from "@apollo/client";
import {
  GameProviderCol,
  GameProviderExtend,
  GameProviderH3,
  GameProviderWrapper,
} from "../styledComponents/StyledGame";
import { StyledButton } from "../styledComponents/CommonStyledComponents";
import { ResetButtonWrapper } from "../styledComponents/StyledSignupLogin";
import { ProviderLogos } from "../styledComponents/StyledFooter";
import { useHistory } from "common/src/router/compat";

export const GameProvidersList = ({
  setSearchResults,
  skin,
  serverSetup,
  vendorsImagePath,
  currentTheme,
  accountRoute,
  setSpinner,
  setSelectedCategory,
  setSelectedProvider,
  pages,
  inGame,
}) => {
  const { t, i18n } = useTranslation("");
  const apolloClient = useApolloClient();
  const [scrollButton, setScrollButton] = useState(false);
  const baseUrl = "/" + i18n.language + "/index";

  const PROVIDER_NAME_TO_SLUG = {
    blueprint: "blueprint-gaming",
    evolution: "evolution-gaming",
    gamesglobal: "games-global",
    hacksaw: "hacksaw-gaming",
    nyx: "lightnwonder",
    nextgen: "lightnwonder",
    playngo: "play-n-go",
    pragmatic: "pragmatic-play",
    relax: "relax-gaming",
    merkur: "merkur-gaming",
    "elk studios": "elk-studios",
    "peter & sons": "peter-and-sons",
    "net ent": "netent",
    "sneaky slots": "sneaky",
    gamingcorps: "gaming-corps",
    slingo: "slingo-games",
  };
  const history = useHistory();

  useEffect(() => {
    if (scrollButton) {
      const timer = setTimeout(() => {
        setScrollButton(false);
      }, 1500);
      return () => clearTimeout(timer);
    }
  }, [scrollButton]);
  const getProviderSlug = (providerName) => {
    const normalized = providerName.toLowerCase();
    return PROVIDER_NAME_TO_SLUG[normalized] || normalized.replace(/\s+/g, "-");
  };

  const gamesforProvider = async (term, providerType) => {
    if (skin === "qbc" || skin === "bec") {
      setSelectedProvider(term);
      history.push(pages["games"]);
    } else if (skin === "pub") {
      history.push(`/${i18n.language}/${getProviderSlug(term)}`);
      return;
    } /* else if (skin === "abc") {
        window.location = `/${i18n.language}/providers/${getProviderSlug(term)}`;
      }  */ else {
      if (window.location.pathname === baseUrl || accountRoute) {
        setSpinner(true);
        setSelectedCategory(null);
        const { loading, errors, data } = await apolloClient.query({
          query: QUERY_SEARCH_GAMES,
          fetchPolicy: "cache-first",
          variables: {
            query: term,
            device: isMobile ? "mob" : "desk",
            country: "rs",
            themeSearch: "false",
            vendorSearch: providerType === "vendor" ? "true" : "false",
            subVendorSearch: providerType === "subVendor" ? "true" : "false",
          },
          //fetchPolicy: 'cache-first',
        });

        if (loading) return <h3>Loading ...</h3>;
        if (errors) return <h1>`Error: ${errors}`</h1>;
        setSearchResults(data.searchGames);
        setSpinner(false);
      }
    }
    document.getElementById("scroll-to-category") &&
      document.getElementById("scroll-to-category").scrollIntoView();
  };

  const handleScrollButton = (e) => {
    e.preventDefault();
    setScrollButton(true);
    document.getElementById("scroll-to-lobby").scrollIntoView();
  };
  return (
    <>
      {!inGame && (
        <GameProviderH3
          dangerouslySetInnerHTML={{
            __html: t(
              "label_providerlogo",
              "Select the provider to show all their games",
            ),
          }}
        ></GameProviderH3>
      )}
      <GameProviderWrapper>
        <GameProviderCol>
          <GameProviderExtend test={scrollButton}>
            {serverSetup.footerLogosGames.map((value, index) => {
              let imageName =
                currentTheme === "light"
                  ? value.footerLogo
                  : value.footerLogoDark;
              return (
                <div
                  className="extra-border"
                  key={index}
                  value={value.providerType}
                  onClick={() =>
                    gamesforProvider(
                      value.name.toLowerCase(),
                      value.providerType,
                    )
                  }
                >
                  {value.footerLogo && value.footerLogoDark && (
                    <ProviderLogos
                      alt=""
                      loading="lazy"
                      src={serverSetup.cdn + vendorsImagePath + "/" + imageName}
                      height="30"
                    />
                  )}
                </div>
              );
            })}
          </GameProviderExtend>
        </GameProviderCol>
      </GameProviderWrapper>
    </>
  );
};
